"use client";
import { useEffect, useMemo, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const websiteUUID = "2eeeecd9-8183-45c1-822d-572a57bbd5b6";

const SCRIPT_SRC_BASE = "https://app.termly.io";

export default function CookieConsentBanner() {
	const scriptSrc = useMemo(() => {
		const src = new URL(SCRIPT_SRC_BASE);
		src.pathname = `/resource-blocker/${websiteUUID}`;
		return src.toString();
	}, []);

	const isScriptAdded = useRef(false);

	useEffect(() => {
		if (isScriptAdded.current) return;
		const script = document.createElement("script");
		script.src = scriptSrc;
		document.head.appendChild(script);
		isScriptAdded.current = true;
	}, [scriptSrc]);

	const pathname = usePathname();
	const searchParams = useSearchParams();

	useEffect(() => {
		//@ts-ignore
		if (typeof window === "undefined" || !window.Termly) {
			return;
		}

		//@ts-ignore
		window.Termly?.initialize();
	}, [pathname, searchParams]);

	return null;
}
